<div class="conteneur" *ngIf="!loading; else loader">
  <div class="fx-direction-row fx-wrap">

    <mat-card appearance="raised" class="card fx-flex-grow" *ngIf="permToDisplayDisponibilites">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon style="margin-right: 5px;" type="do" icon="jour-ferie">
          </app-icon>
          <span>Disponibilités</span>
        </mat-card-title>
        @if(permToEdit){
        <button mat-mini-fab color="primary" matTooltip="Modifier" routerLink="/account/assmat/availability">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </mat-card-header>
      <mat-card-content>
        <div class="info-grid"
          [ngStyle]="{'grid-template-columns': availability.length > 1 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'}">
          @for(item of availability; track item;){
          <div class="info-item">
            <div class="fx-direction-row fx-between-start">
              <div class="info-value">
                <div class="info-line">
                  <label>Dates :</label>
                  {{item.dateDebut && !item.dateFin ? 'À partir du' : !item.dateDebut && item.dateFin ? "Jusqu'au" :
                  !item.dateDebut && !item.dateFin ? "" : 'Du'}}
                  {{item.dateDebut | date:"shortDate"}} {{item.dateFin && item.dateDebut ? 'au' : ''}}
                  {{item.dateFin | date:"shortDate"}}
                </div>
                <div class="info-line">
                  <label>Capacité :</label>
                  {{item.capacite}}
                </div>
                @if (configMentalo.displayAgrementSecondaire) {
                <div class="info-line">
                  <label>Agrément secondaire :</label>
                  {{item.agrementSecondaire.designation ?
                  item.agrementSecondaire.designation : "Aucun"}}
                </div>
                }
              </div>
              <div class="fx-direction-row fx-between-center" style="margin-bottom: 8px;">
                @if (item.active) {
                <mat-icon class="primary">event_available</mat-icon>
                }@else {
                <mat-icon class="warn">event_busy</mat-icon>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </mat-card-content>
    </mat-card>

    @if(permToDisplayFormations){
    <mat-card appearance="raised" class="card fx-flex-grow">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon style="margin-right: 5px;" type="do" icon="formation">
          </app-icon>
          <span>Formations</span>
        </mat-card-title>
        @if(permToEdit){
        <button mat-mini-fab color="primary" matTooltip="Modifier" routerLink="/account/assmat/formation">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </mat-card-header>
      <mat-card-content>
        <div class="info-grid">
          @for(formation of formations; track formation;){
          <div class="info-item">
            <div class="fx-direction-row fx-between-start">
              <div class="info-value">
                <div class="info-line">
                  <label>Programme :</label>
                  {{formation.programme}}
                </div>
                <div class="info-line">
                  <label>Dates :</label>
                  {{formation.dateDebut && !formation.dateFin ? 'À partir du' : !formation.dateDebut &&
                  formation.dateFin ?
                  "Jusqu'au" :
                  !formation.dateDebut && !formation.dateFin ? "" : 'Du'}}
                  {{formation.dateDebut | date:"shortDate"}} {{formation.dateFin && formation.dateDebut ? 'au' : ''}}
                  {{formation.dateFin | date:"shortDate"}}
                </div>
                @if(formation.lieu){
                <div class="info-line">
                  <label>Lieu :</label>
                  {{formation.lieu}}
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
    }

    @for (step of assmatFormSteps; track $index) {
    <mat-card appearance="raised" class="card"
      [ngClass]="{'multiple-card': assmatFormSteps.length > 1, 'one-card': assmatFormSteps.length <= 1 }">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          @if (step.stepName === 'souhaitsAccueil') {
          <app-icon style="margin-right: 5px;" type="do" icon="accueil" />
          }
          @if (step.stepName === 'valeursLibres') {
          <mat-icon style="margin-right: 5px;">description</mat-icon>
          }
          @if (step.stepName === 'mam') {
          <app-icon style="margin-right: 5px;" type="do" icon="mam" />
          }

          @if (step.stepName === 'coordinates') {
          <mat-icon style="margin-right: 5px;">contacts</mat-icon>
          }
          <span>{{ step.label }}</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" [matTooltip]="permToEdit ? 'Modifier' : 'Voir'"
          routerLink="/account/assmat/{{step.stepName}}">
          @if (permToEdit) {
          <mat-icon>edit</mat-icon>
          }@else {
          <mat-icon>visibility</mat-icon>
          }
        </button>
      </mat-card-header>
      <mat-card-content>
        @if(step.stepName === 'coordinates'){
        <ng-container [ngTemplateOutlet]="coordinates"></ng-container>
        }
        @if (step.stepName === 'souhaitsAccueil') {
        <ng-container [ngTemplateOutlet]="souhaitsAccueil"></ng-container>
        }
        @if (step.stepName === 'mam') {
        <ng-container [ngTemplateOutlet]="mam"></ng-container>
        }
        @if (step.stepName === 'valeursLibres') {
        <ng-container [ngTemplateOutlet]="valeursLibres"></ng-container>
        }
      </mat-card-content>
    </mat-card>
    }
  </div>
</div>

<ng-template #mam>
  @if (selectedMAM) {
  <div class="info-grid">
    <div class="info-item">
      <span class="info-label">Désignation</span>
      <span class="info-value">
        {{selectedMAM.designation}}
      </span>
    </div>

    <div class="info-item">
      <span class="info-label">Adresse</span>
      <span class="info-value">
        {{ selectedMAM.numRue }} {{ selectedMAM.rue1 }} <br>
        @if (selectedMAM.rue2) {
        <span>{{ selectedMAM.rue2 }}<br></span>
        }
        @if (selectedMAM.rue3) {
        <span>{{ selectedMAM.rue3 }}<br></span>
        }
        <span>{{ selectedMAM.codePostal }} {{ selectedMAM.ville }}</span>
      </span>
    </div>

    @if (selectedMAM.telephone || selectedMAM.email) {
    <div class="info-item">
      <span class="info-label">Contacts</span>
      <div class="info-value">
        @if(selectedMAM.email){
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>local_phone</mat-icon>
          {{ selectedMAM.telephone }}
        </div>
        }
        @if(selectedMAM.email){
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>alternate_email</mat-icon>
          {{selectedMAM.email}}
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
</ng-template>

<ng-template #valeursLibres>
  <div class="info-grid">
    @for(valeurLibre of listValeursLibres; track $index){
    <div class="info-item">
      @switch (valeurLibre.type) {
      @case('datepicker'){
      <span class="info-label">{{valeurLibre.label}}</span>
      <span class="info-value">
        {{valeurLibre.value | date:"shortDate"}}
      </span>
      }
      @default {
      <span class="info-label">{{valeurLibre.label}}</span>
      <span class="info-value">
        {{valeurLibre.value}}
      </span>
      }
      }
    </div>
    }
  </div>
</ng-template>

<ng-template #coordinates>
  <div class="info-grid">
    @if (assmatData.emailPro || assmatData.telephonePro) {
    <div class="info-item">
      <span class="info-label">Contacts professionnels</span>
      <div class="info-value">
        @if(assmatData.emailPro){
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>local_phone</mat-icon>
          {{ assmatData.emailPro }}
        </div>
        }
        @if(assmatData.telephonePro){
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>alternate_email</mat-icon>
          {{assmatData.telephonePro}}
        </div>
        }
      </div>
    </div>
    }
  </div>
</ng-template>

<ng-template #souhaitsAccueil>

  <div class="info-grid">
    @if(complement){
    @if(complement.nbEnfantSouhait){
    <div class="info-item">
      <span class="info-label">Nombre d'enfant souhaité</span>
      <div class="info-value">
        {{complement.nbEnfantSouhait}}
      </div>
    </div>
    }
    @if(complement.ageDebutEnfantSouhait && complement.ageFinEnfantSouhait){
    <div class="info-item">
      <span class="info-label">Tranche d'âge souhaitée</span>
      <div class="info-value">
        Entre {{complement.ageDebutEnfantSouhait}} et
        {{complement.ageFinEnfantSouhait}} mois
      </div>
    </div>
    }
    }

    @if(modeAccueil){
    <div class="info-item">
      <span class="info-label">Mode(s) d'accueil(s) souhaité(s)</span>
      <div class="info-value">
        <ul style="margin: 0;">
          <li *ngIf="modeAccueil.accueilTempsComplet === 'Oui'">
            Temps Complet
          </li>
          <li *ngIf="modeAccueil.accueilTempsPartiel === 'Oui'">
            Temps Partiel
          </li>
          <li *ngIf="modeAccueil.accueilPeriscolaire === 'Oui'">
            Accueil periscolaire
          </li>
          <li *ngIf="modeAccueil.accueilAtypique === 'Oui'">
            Accueil avec horaires atypiques
          </li>
          <li *ngIf="modeAccueil.accueilUrgence === 'Oui'">
            Accueil en urgence
          </li>
          <li *ngIf="modeAccueil.accueilHandicap === 'Oui'">
            Accueil d'un enfant en situation de handicap
          </li>
          <li *ngIf="modeAccueil.accueilNuit === 'Oui'">
            Accueil nuit
          </li>
          <li *ngIf="modeAccueil.accueilWeekend === 'Oui'">
            Accueil weekend
          </li>
          <li *ngIf="modeAccueil.accueilDepannage === 'Oui'">
            Accueil dépannage
          </li>
          <li *ngIf="modeAccueil.accueilMercrediVacScolaires === 'Oui'">
            Accueil mercredis / vacances scolaires
          </li>
        </ul>
      </div>
    </div>
    }
  </div>
</ng-template>

<ng-template #loader>
  <app-loader message="Chargement des données..." class="margin"></app-loader>
</ng-template>